import script from "./dialogBox.vue?vue&type=script&setup=true&lang=js"
export * from "./dialogBox.vue?vue&type=script&setup=true&lang=js"

import "./dialogBox.vue?vue&type=style&index=0&id=707677cf&lang=scss"

const __exports__ = script;

export default __exports__